/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import { partition, uniqBy } from 'lodash'
import NotFoundMediaImage from '~/assets/projects/not_found_media.png'
import { NotFoundError } from '~/errors/NotFoundError'
import ProjectAsset from '~/models/ProjectData/ProjectAsset'
import ProjectTextAsset from '~/models/ProjectData/ProjectTextAsset'
import ProjectTransitionAsset from '~/models/ProjectData/ProjectTransitionAsset'
import * as API from '~/ServerAPI'
import { SOURCE_FILE_TYPES } from '~/enums'
import ProjectVideoAsset from '~/models/ProjectData/ProjectVideoAsset'
import { isText, isTransition } from '~/Util/assets'
import { getTransitionMountType } from './getTransitionMountType'
import { COLOR_PRIMARIES } from '~/constant'
import ProjectImageAsset from '~/models/ProjectData/ProjectImageAsset'

const handleDeletedMedia = (asset, error) => {
  asset.thumbnail = NotFoundMediaImage
  asset.mediaDeleted = true
  asset.errorMessage = error.message
  asset.errorType = error.type
  asset.sourceFileType = SOURCE_FILE_TYPES.MEDIA
}

export const isFrontendLib = asset => (
  asset instanceof ProjectTextAsset
  || asset instanceof ProjectTransitionAsset
  || isTransition(asset?.type)
  || isText(asset?.type)
)

export const prepareProjectAssets = async assets => {
  const MAX_REQUESTS = 5
  const sentIds = []
  const [ frontendLibAssets, restProjectAssets ] = partition([ ...assets ], isFrontendLib)
  while (restProjectAssets.length) {
    const requests = []
    const dispatchGroup = uniqBy(restProjectAssets.splice(0, MAX_REQUESTS), a => a.fileId)
      .filter(asset => !sentIds.includes(asset.fileId))
    for (let i = 0; i < dispatchGroup.length; i++) {
      const asset = dispatchGroup[i]
      const { fileId } = asset
      if (!fileId) {
        for (const pAsset of assets) {
          if (!pAsset.colorPrimaries && (pAsset instanceof ProjectVideoAsset
            || pAsset instanceof ProjectImageAsset)) {
            pAsset.colorPrimaries = COLOR_PRIMARIES.BT709
          }
          if (pAsset.fileId === asset.fileId) {
            handleDeletedMedia(pAsset, 'No file')
          }
        }
        continue
      }

      if (asset instanceof ProjectAsset) {
        requests.push(
          API.getMediaFile(fileId)
            .then(({ data }) => {
              const { thumbnail, previewUrl,
                filetype, colorPrimaries } = data ?? {}
              for (const pAsset of assets) {
                if (pAsset.fileId === fileId) {
                  if (!pAsset.fileType) {
                    pAsset.fileType = filetype
                  }
                  if (pAsset instanceof ProjectVideoAsset
                    || pAsset instanceof ProjectImageAsset) {
                    pAsset.colorPrimaries = colorPrimaries ?? COLOR_PRIMARIES.BT709
                  }
                  if (pAsset instanceof ProjectVideoAsset) {
                    pAsset.codecsInfo = data.codecsInfo
                    pAsset.fpsNum = data.fpsNum
                    pAsset.fpsDenum = data.fpsDenum
                    pAsset.dfFlag = data.dfFlag
                    pAsset.startTimeCodeFrames = data.startTimeCodeFrames
                    pAsset.videoEncoderParams = data.videoEncoderParams || ''
                    pAsset.videoEncoderParsedParams = data.videoEncoderParsedParams || ''
                  }
                  if (!pAsset.thumbnail && thumbnail) {
                    pAsset.thumbnail = thumbnail
                  }
                  if (previewUrl) {
                    pAsset.url = previewUrl
                  } else {
                    handleDeletedMedia(pAsset, 'No video url')
                  }
                }
              }
            })
            .catch(e => {
              for (const pAsset of assets) {
                if (pAsset.fileId === asset.fileId) {
                  if (e instanceof NotFoundError) {
                    handleDeletedMedia(pAsset, e)
                  } else {
                    console.error(pAsset, e)
                  }
                }
              }
            })
        )
      }
      sentIds.push(fileId)
    }
    // eslint-disable-next-line
    await Promise.all(requests)
  }
  for (const asset of frontendLibAssets) {
    if (asset instanceof ProjectTransitionAsset) {
      const { data } = API.fetchTransition(asset.type)
      if (data?.previewUrl) {
        asset.previewUrl = data.previewUrl
      }
      asset.mountType = getTransitionMountType(asset)
    }
  }
}
